exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-content[data-v-7e05674a] {\n  height: calc(100vh - 20px);\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  gap: 16px;\n}\n.picker[data-v-7e05674a] {\n  display: flex;\n  gap: 24px;\n  flex-grow: 1;\n  height: 100%;\n  overflow-y: hidden;\n}\n.picker .cards-content[data-v-7e05674a] {\n  flex-grow: 1;\n  overflow-y: auto;\n  gap: 16px;\n  display: flex;\n  flex-direction: column;\n}", ""]);

// exports
